// extracted by mini-css-extract-plugin
module.exports = {"modal-top-panel":"TopPanel_modal-top-panel__2TEKa","modal-top-panel-text":"TopPanel_modal-top-panel-text__1zijC","modal-top-panel-button":"TopPanel_modal-top-panel-button__3PAwe"};